export const MILK_COLLECTION_PAGE_SIZE_OPTIONS = [10, 20, 50];
export const DEFAULT_MILK_COLLECTION_PAGE_SIZE = 20;

export const getTotalPages = (items, pageSize = DEFAULT_MILK_COLLECTION_PAGE_SIZE) => {
  const totalItems = Array.isArray(items) ? items.length : 0;
  if (pageSize <= 0) return 1;
  return Math.max(1, Math.ceil(totalItems / pageSize));
};

export const paginateMilkCollectionItems = (
  items,
  page,
  pageSize = DEFAULT_MILK_COLLECTION_PAGE_SIZE
) => {
  if (!Array.isArray(items) || pageSize <= 0) return [];
  const totalPages = getTotalPages(items, pageSize);
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const start = (safePage - 1) * pageSize;
  return items.slice(start, start + pageSize);
};

export const milkCollectionRangeForPage = (
  items,
  page,
  pageSize = DEFAULT_MILK_COLLECTION_PAGE_SIZE
) => {
  if (!Array.isArray(items) || items.length === 0 || pageSize <= 0) {
    return { start: 0, end: 0 };
  }
  const totalPages = getTotalPages(items, pageSize);
  const safePage = Math.min(Math.max(page, 1), totalPages);
  const start = (safePage - 1) * pageSize + 1;
  const end = Math.min(safePage * pageSize, items.length);
  return { start, end };
};
